import {
	MimaButton,
	MimaInput,
	MimaText,
	PageLoader,
	ReceiptCheckBox as RCB,
} from '../../components';
import styles from '../../assets/styles/Login/Login.module.scss';
import { Formik } from 'formik';
import React from 'react';

const LoginForm = ({
	validationSchema,
	onSubmit,
	loading,
	owner,
	selectOwnerAccount,
}) => {
	return (
		<Formik
			initialValues={{
				email: '',
				accountType: 'Business',
				password: '',
			}}
			validationSchema={validationSchema()}
			onSubmit={onSubmit}>
			{({
				handleChange,
				handleBlur,
				handleSubmit,
				setFieldValue,
				values,
				errors,
				touched,
			}) => (
				<div>
					<MimaInput
						labelTitle="Email address"
						type="text"
						placeholder="Enter your email address"
						id="email"
						name="email"
						value={values.email}
						onChange={handleChange('email')}
						onBlur={handleBlur('email')}
						error={errors.email}
						touched={touched.email}
					/>
					<MimaInput
						labelTitle="Password"
						type="text"
						placeholder="Enter your password"
						id="password"
						name="password"
						value={values.password}
						onChange={handleChange('password')}
						onBlur={handleBlur('password')}
						passwordIcon
						error={errors.password}
						touched={touched.password}
					/>
					<MimaButton
						title="Login"
						onClick={handleSubmit}
						type="submit"
						loading={loading}
						variant="form"
					/>
				</div>
			)}
		</Formik>
	);
};

export default LoginForm;
